import queryString from 'query-string'
import apiClient from './api-client'

function list(cycleId, page, query, billed) {
  const options = { withHeaders: true }
  const queryParams = page === 'all' ? { all: true } : { page }

  if (query) {
    queryParams.query = query
  }

  if (billed && billed !== 'all') {
    queryParams.billed = billed
  }

  return apiClient.get(
    queryString.stringifyUrl({
      url: `/cycles/${cycleId}/billing-orders`,
      query: queryParams,
    }),
    options,
  )
}

function create(cycleId, billingOrder) {
  return apiClient.post(`/cycles/${cycleId}/billing-orders`, billingOrder)
}

function update(id, billingOrderData) {
  return apiClient.patch(`billing-orders/${id}`, billingOrderData)
}

function get(id) {
  return apiClient.get(`billing-orders/${id}`)
}

function destroy(id) {
  return apiClient.destroy(`billing-orders/${id}`)
}

function markAsBilled(id, payload) {
  return apiClient.put(`billing-orders/${id}/billed`, payload)
}

function listCPTCodes(practiceId, cycleId) {
  const options = { withHeaders: true }
  const query = {}

  if (cycleId) query.cycle_id = cycleId

  return apiClient.get(
    queryString.stringifyUrl({
      url: `/practices/${practiceId}/billing-orders/remote/cpt-codes`,
      query,
    }),
    options,
  )
}

export default {
  destroy,
  list,
  get,
  markAsBilled,
  create,
  update,
  listCPTCodes,
}
